<section class="new-training" fxLayout fxLayoutAlign="center">
  <form></form>
  <mat-card fxFlex.xs="100%" fxFlex="400px">
    <mat-card-title fxLayoutAlign="center">Time to start a workout!</mat-card-title>
    <mat-card-content fxLayoutAlign="center">
      <mat-form-field>
        <mat-label>Choose Exercise</mat-label>
        <mat-select [(ngModel)]="selectedExercise">
          <mat-option   *ngFor="let exercise of exercises" [value] ="exercise.id" >
            {{ exercise.name }}
          </mat-option>

        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions fxLayoutAlign="center">
      <button type="submit" mat-raised-button color="accent" (click)="onStartTraining(selectedExercise)" [disabled]="selectedExercise===''">Start</button>
    </mat-card-actions>
  </mat-card>
</section>
